import React, { useContext } from 'react'
import { Input } from '@/style-guide'
import { Form, Button } from 'antd'
import { AuthContext } from '../AuthContext'
export const ResetPassword = () => {
  const [form] = Form.useForm()
  const { setStep, setPayload, payload } = useContext(AuthContext)
  const submit = (values) => {
    setPayload({ ...payload, password: values.password })
    setStep('confirm-email')
  }

  return (
    <Form
      form={form}
      onFinish={submit}
      initialValues={{ password: '', confirmPassword: '' }}
    >
      <Form.Item
        name="password"
        rules={[
          {
            required: true,
            message: 'Please input your password!',
          },
          {
            pattern: new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})'),
            message:
              'Needs to be at least 8 characters long with at least one number and one special character',
          },
        ]}
      >
        <Input label="Password" htmlType="password" />
      </Form.Item>
      <Form.Item
        name="confirmPassword"
        rules={[
          {
            required: true,
            message: 'Please confirm your password!',
          },

          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('password') === value) {
                return Promise.resolve()
              }
              return Promise.reject(
                new Error('The two passwords that you entered do not match!')
              )
            },
          }),
        ]}
      >
        <Input label="Re-enter password" htmlType="password" />
      </Form.Item>
      <Form.Item>
        <Button
          type="primary"
          block
          htmlType="Submit"
          primary
          size="large"
          style={{ height: '60px' }}
        >
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}
